import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';

import * as Actions from 'actions';
import * as ActionTypes from 'constants';

class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'EditUser';

        this.cancel = this.cancel.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
    }
    cancel() {
    	this.props.dispatch(Actions.hideDeleteUserPrompt());
    }
    deleteUser() {
    	this.props.dispatch(Actions.beginDeleteUser());
    }
    render() {
    	let user = this.props.users.tmp_user;

      return (
        <div>
        	{(() => {
        			return (
        				<Modal
			        		show={this.props.users.show_delete_user_prompt}
			        		onHide={this.cancel}
			        		bsSize="small">
			        		<div className="panel panel-primary mb-none">
			        			<div className="panel-heading">
			        				<h3 className="panel-title">Delete User?</h3>
			        			</div>
			        			<div className='panel-body'>
			        			{(() => {
			        				if(user)
			        					return <h4>Delete {user.name && user.name.first && user.name.last ? `${user.name.first} ${user.name.last}` : user.username}</h4>
			        			})()}
			        			</div>
			        			<div className='panel-footer'>
			        				<div className='row'>
			        					<div className='col-md-6 mb-sm'>
			        						<div onClick={this.deleteUser} className='btn btn-block btn-danger'>Confirm</div>
			        					</div>
			        					<div className='col-md-6 mb-sm'>
			        						<div onClick={this.cancel} className='btn btn-block btn-default'>Cancel</div>
			        					</div>
			        				</div>
			        			</div>
			        		</div>
			        	</Modal>
        			)
        	})()}
        </div>
      );
    }
}

export default connect(({users}) => ({users}))(EditUser);



// WEBPACK FOOTER //
// ./src/browser/components/users/deleteUserModal.js